module.exports = __webpack_public_path__ + "images/emoji/shaved_ice.fe516a24a057239af2ea.png";